// db.ts
import Dexie, {  type Table } from 'dexie';
import 'dexie-observable';
import 'dexie-syncable';
// import 'your-sync-protocol-implementation';

import DataBaseTests from './DataBaseTests';
import { CatDB } from './DataTypes/CategoryData';
import CategoryData from './DataTypes/CategoryData';
import { EntryDB } from './DataTypes/Entry';
import Helpers from './Helpers';
import { ExportImport_ } from './ExportImport';
import Data from './Data';
import { UserPrefs } from './UserPrefs';
import type { ApplyRemoteChangesFunction, IPersistedContext, ISyncProtocol, PollContinuation, ReactiveContinuation } from 'dexie-syncable/api';
import type { IDatabaseChange } from 'dexie-observable/api';



class SyncProtocol implements ISyncProtocol
{
	partialsThreshold?: number | undefined;
	POLL_INTERVAL = 10000; // Poll every 10th second

	//description of all variables here: https://dexie.org/docs/Syncable/Dexie.Syncable.ISyncProtocol

	//URL of the remote node to establish a continuos sync with.
	//changes will be an array of objects such as (IDatabaseChange): 
	/*
	{
  "type": 1,
  "table": "entry_attributes",
  "key": "3902a0c3-1ea8-48c1-a208-fca3e37e205c",
  "obj": {
    "id": "3902a0c3-1ea8-48c1-a208-fca3e37e205c",
    "id_user": "d75d0174-4841-424f-c5f8-5447a7cb6a01",
    "id_cat": "a9543885-c821-4d67-ac17-5aabe24b9a83",
    "id_item_type": "78e356f3-47e7-4b95-e6a6-72a19673485d",
    "id_entry": "e026b6ad-f446-4642-a8c9-51ae0f10f25c",
    "name": "Difficulty",
    "value": "Very Hard",
    "timestamp": 1692412029775,
    "date_updated": "2023-08-19T02:27:09.775Z",
    "rating": 1
  }
}
	*/
	sync(context: IPersistedContext, url: string, options: any, baseRevision: any, syncedRevision: any, 
		changes: IDatabaseChange[], partial: boolean, applyRemoteChanges: ApplyRemoteChangesFunction, 
		onChangesAccepted: () => void, onSuccess: (continuation: PollContinuation | ReactiveContinuation) => void, 
		onError: (error: any, again?: number | undefined) => void
		): void
	{
		if(changes.length<1)
		{
			console.log("ISyncProtocol: changes = 0, returning")
			context.save()
                            .then(() => {
                            // Since we got success, we also know that server accepted our changes:
                            onChangesAccepted();
							console.log("ISyncProtocol on changes accepted!");
                            // Convert the response format to the Dexie.Syncable.Remote.SyncProtocolAPI specification:
                            // applyRemoteChanges (data.changes, data.currentRevision, data.partial, data.needsResync);
                            onSuccess({ again: this.POLL_INTERVAL });
                            })
                            .catch((e) => {
                                // We didn't manage to save the clientIdentity stop synchronization
								console.log("ISyncProtocol something went wrong");
                                onError(e, Infinity);
                            });

			return;
		}

		// console.error('ISyncProtocol: Method not implemented.');
		console.warn('ISyncProtocol: context:', context, "url: ", url, "options: ", options, "baseRevision: ", baseRevision, "syncedRevision: ",syncedRevision,
		"changes: ", changes, "partial: ", partial, "applyRemoteChanges", applyRemoteChanges,
		"onChangesAccepted: ", onChangesAccepted, "onSuccess: ", onSuccess, "onError: ", onError
		);

		var request = {
            clientIdentity: context.clientIdentity || null,
            baseRevision: baseRevision,
            partial: partial,
            changes: changes,
            syncedRevision: syncedRevision
        };
		console.warn("ISyncProtocol request is: ", request, "changes: ", changes);

		//goig to base our implementation on the one from: https://github.com/dexie/Dexie.js/blob/master/samples/remote-sync/ajax/AjaxSyncProtocol.js
		// Send the request:
		(async () => {
			console.log("ISyncProtocol sending fetch request!");

			const rawResponse = await fetch("http://localhost:3000/sync", {
			method: 'POST',
			headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
			},
			body: JSON.stringify({"a": 1, "b": 'Textual content'})
		});
			const content = await rawResponse.json();	
			console.log("ISyncProtocol fetch response: ", content);

			//lets say it was a success for now
			let error = true;
			let data = {changes:[], partial:false} as any;

			if(error)
				// onError("ISyncProtocol oh no she didn't!", Infinity); // Infinity = Don't try again. We would continue getting this error.
				onError("ISyncProtocol oh no she didn't!", this.POLL_INTERVAL); // Infinity = Don't try again. We would continue getting this error.
			else
			{
				

				context.save()
                            .then(() => {
                            // Since we got success, we also know that server accepted our changes:
                            onChangesAccepted();
							console.log("ISyncProtocol on changes accepted!");
                            // Convert the response format to the Dexie.Syncable.Remote.SyncProtocolAPI specification:
                            applyRemoteChanges (data.changes, data.currentRevision, data.partial, data.needsResync);
                            onSuccess({ again: this.POLL_INTERVAL });
                            })
                            .catch((e) => {
                                // We didn't manage to save the clientIdentity stop synchronization
								console.log("ISyncProtocol something went wrong");
                                onError(e, Infinity);
                            });
			}

		})();
		

		
	}
}
// commenting out- didn't get fully working with sync protocol- switching over to supabase instead/ no offline solution
// Dexie.Syncable.registerSyncProtocol("my_sync_protocol", new SyncProtocol())

//ERROR FOR FUTURE NOTe:
//WHEN YOU GET: "KeyPath testingg on object store users is not indexed"
//IT MEANS: "You have to both set a variable for the class, and also below when you pass that class into dexieJS!"
//so don't just update the class- find where dexiejs uses that class and also tell it there that new variable has been added


/* console.warn(`WARNING: BUG IN DEXIEJS: When adding a variable for a class saved out by dexiejs, 
you both have to add it to the class, and in a seperate area where you tell it what class to use + which variables are in that class.... otherwise it gives useless error: 
 'KeyPath is not indexed' - 
`
); */

// console.warn("WARNING: BUG IN DEXIEJS: when trying to get a item by id, only works with : equals(\":id\")");

// export interface EntryDB 
// {
//   id?: number;
//   name: string;
//   date_updated: Date;
//   id_cat:number;
// }

//all the different models/ types going into the database
/* export class CatDB 
{
  id?: number;
  name!: string;
  color_bg!: string;
  color_txt!: string;
  icon!: string;
  date_updated!: Date;
} */

//dummy object to allow me to know when dexiejs has been created, so I can populate when it hasn't, but also clear everythign else out to allow a reset
export class ZZDexieJSExists 
{
  id!: string; 
}

export class UserDB 
{
  id!: string;
  timestamp!:number;
  name!: string;
  date_updated!: Date;
  
  constructor(obj:any)
  {
      // super({});//if we actually pass the object using super, it will only copy over the variables on the parent class- not the current class, so have to do it again

      // Object.assign(this, obj);
      Helpers.CopyObject(this, obj);
      if(!this.date_updated)
        this.date_updated = new Date();

    //generate timestamp from date
    if(!this.timestamp)
        this.timestamp=this.date_updated.getTime();


        // await db.users.where("timestamp").equals(this.timestamp)

      return this;
  }
}

/* export class DayDB
{
  id!: number; 
  date!: Date;
  summary!: string;

  //days will contain all entries on export/ import

  constructor(obj:any)
  {
      Helpers.CopyObject(this, obj);
      if(!this.date)
        this.date = new Date();
      return this;
  }
}  */

export class ItemTypeDB 
{
  id!: string;
  id_user!:string;
  id_cat!:string;
  name!: string;
  date_updated!: Date;
  
  constructor(obj:any)
    {
        //this allows us to copy all the variables/ proporties from a generic object to our current object (without haviung to do it manually, one by one)
        //BUG: this will copy all properties from the other object over, not just the ones that should be copied over
        // Object.assign(this, obj);
        // console.log("itemtype db, going to copy");
        Helpers.CopyObject(this, obj);
        // console.log("itemtype db, finishedcopy");
    }
}
// export class EntryDB 
// {
//   id?: number;
//   id_cat!:number;
//   id_item_type!:number;
//   date_updated!: Date;
//   date_finished!: Date;
// }

//for having additional data on each day aside from summary
/* export class DayAttributeDB 
{
  id?: number;
  id_day!:number;
  name!: string;
  value?: string;
  date_updated!: Date;
  rating!:number;
  constructor()
  {
    this.id=-1;
    return this;
  }
  Assign(obj:any)//for copying over proxy vue object to actual object
  {
    Helpers.CopyObject(this, obj);
    if(this.id==-1)
        this.id=undefined;
    return this;
  }
} */

export class EntryAttributeDB 
{
  id?: string;
  id_user!:string;
  id_cat!:string;
  id_item_type!:string;
  id_entry!:string;

  name!: string;
  value?: string;
  timestamp!:number;
  date_updated!: Date;
  rating!:string;
  constructor()
  {
    this.id="-1";
    
    return this;
  }
  Assign(obj:any)//for copying over proxy vue object to actual object
  {
    // Object.assign(this, obj);
    Helpers.CopyObject(this, obj);
    if(this.id=="-1")
        this.id=undefined;

    //generate timestamp from date
    if(!this.timestamp)
    {
      if(!this.date_updated)
        this.date_updated = new Date();

        this.timestamp=this.date_updated.getTime();
    }
    else if(!this.date_updated)
      this.date_updated = new Date(this.timestamp);


    return this;
  }
  CreateAttribute(id_cat:string, id_item_type:string, id_entry:string, id_user:string)
  {
    this.name=""; this.value=""; this.rating="-1";this.date_updated = new Date();this.id_user=id_user;

    //generate timestamp from date
    if(!this.timestamp)
        this.timestamp=this.date_updated.getTime();

    this.id_cat=id_cat; this.id_item_type=id_item_type; this.id_entry=id_entry;
    return this;
  }
  CreateAttributeFromEntry(entry:EntryDB)
  {
    return this.CreateAttribute(entry.id_cat, entry.id_item_type, entry.id, entry.id_user);
  }
  Create(name:string, value:string, rating:string)
  {
    this.name=name; this.value=value; this.rating=rating;this.date_updated = new Date();
    
    //generate timestamp from date
    if(!this.timestamp)
        this.timestamp=this.date_updated.getTime();

    return this;
  }
}

export class MySubClassedDexie extends Dexie 
{
  // 'friends' is added by dexie when declaring the stores()
  // We just tell the typing system this is the case
  // entries!: Table<EntryDB>; 
  // count:number=10;
  users!: Table<UserDB>;
  // days!: Table<DayDB>;
  // day_attributes!: Table<DayAttributeDB>;
  cats!: Table<CatDB>; 
  item_types!: Table<ItemTypeDB>; 
  entries!: Table<EntryDB>; 
  entry_attributes!: Table<EntryAttributeDB>;
  zzdexiejs_exists!: Table<ZZDexieJSExists>; 

  constructor() 
  {
    console.log("Dexie DB being created!");
    super('HealthTracker');
    // this.version(1).stores(
    //   {
    //     //lets base it off of 'DatabaseTests instead
    //     //entries: '++id, name, date_updated, id_cat' // Primary key and indexed props
    //     cats: '++id, name, date_updated, color_txt, color_bg, icon',
    //     item_types: '++id, id_cat, name, date_updated',
    //     item_entries: '++id, id_cat, id_item_type, date_updated, date_finished',
    //     entry_attributes: '++id, id_cat, id_item_type, entry_id, name, value, date_updated',
    // });
  }
}


console.log("commenting out new dexieDB subclass");
export const db:any={};
// export const db = new MySubClassedDexie();

//1 baseline
//1.1 adding type to cats
/* db.version(1.1).stores(
  {
    //lets base it off of 'DatabaseTests instead
    //entries: '++id, name, date_updated, id_cat' // Primary key and indexed props
    users: '$$id, timestamp, name, date_updated',
    // days: '++id,  date, summary',
    // day_attributes: '++id,  id_day, name, value, date_updated',
    cats: '$$id, timestamp, id_user, name, type, date_updated, color_txt, color_bg, icon',
    item_types: '$$id, id_user, id_cat, name, date_updated',
    entries: '$$id, timestamp, id_user, id_cat, id_item_type, date_updated, date_finished, item_type, attributes, has_duration, tracking',
    entry_attributes: '$$id, timestamp, id_user, id_cat, id_item_type, id_entry, name, value, date_updated',
	zzdexiejs_exists: '$$id',
}); */





// let populate_test_data = false;
//populate test data
// if(populate_test_data)
//categories to add for all users
export let cats_default = [
  {name:"Food", type:"food", color_bg:"#0000FF", color_txt:"#FFFFFF", icon:"restaurant", date_updated:DataBaseTests.GetDate(-22)}, 
  {name:"Bathroom",type:"bathroom", color_bg:"#8a2d00", color_txt:"#FFFFFF", icon:"wc", date_updated:DataBaseTests.GetDate(-25)},
  {name:"Exercise",type:"exercise", color_bg:"#FFFF00", color_txt:"#000000", icon:"sports_martial_arts", date_updated:DataBaseTests.GetDate(-12)},
  {name:"Mood", type:"mood", color_bg:"#0000FF", color_txt:"#FFFFFF", icon:"mood", date_updated:DataBaseTests.GetDate(-2)},
  {name:"Medicine",type:"medicine", color_bg:"#820082", color_txt:"#FFFFFF", icon:"pill", date_updated:DataBaseTests.GetDate(-24)},
  {name:"Sleep",type:"sleep", color_bg:"#FF0000", color_txt:"#FFFFFF", icon:"king_bed", date_updated:DataBaseTests.GetDate(-38)},
  {name:"Summary",type:"summary", color_bg:"#ff5400", color_txt:"#000000", icon:"receipt_long", date_updated:DataBaseTests.GetDate(-38)},
  {name:"Weather",type:"weather", color_bg:"rgb(50, 242, 206)", color_txt:"#000000", icon:"thermostat", date_updated:DataBaseTests.GetDate(-38)},
];

let food_entries = [{name:"Eggs and Sausage and peppers", date_updated:DataBaseTests.GetDate(-24)},
{name:"Pastrami sandwich on rye", date_updated:DataBaseTests.GetDate(-20)},
{name:"Salad", date_updated:DataBaseTests.GetDate(-18)},
];
let attrs_food_0 = [{name:"Calories", value:"300",rating:-1}, {name:"Fat", value:"10g",rating:-1},  {name:"Filling?", value:"Yes",rating:10}];

let bathroom_entries = [{name:"Normal consistancy, brown, not urgent", date_updated:DataBaseTests.GetDate(-28), date_finished:DataBaseTests.GetDate(-27), has_duration:true},
{name:"Terrible, no good, very bad", date_updated:DataBaseTests.GetDate(-18), date_finished:DataBaseTests.GetDate(-16), has_duration:true},
];
let attrs_bathroom_0 = [{name:"Color", value:"brown",rating:10}, {name:"Floater", value:"yes",rating:5}];

let exercise_entries = [{name:"Weight Lifting", date_updated:DataBaseTests.GetDate(-19), date_finished:DataBaseTests.GetDate(-18), has_duration:true},
{name:"Short Walk", date_updated:DataBaseTests.GetDate(-12), date_finished:DataBaseTests.GetDate(-11), has_duration:true},
];
let attrs_exercise_0 = [{name:"Difficulty", value:"Very Hard",rating:1}, {name:"Max Weight", value:"100lbs",rating:1}];

let mood_entries = [{name:"Hangry", date_updated:DataBaseTests.GetDate(-10)},
{name:"Sleepy", date_updated:DataBaseTests.GetDate(-2)},
];
let attrs_mood_0 = [{name:"Craving cheese", value:"",rating:-1}];

let medicine_entries = [{name:"Multivitamin", date_updated:DataBaseTests.GetDate(-15)},
{name:"Fish Oil", date_updated:DataBaseTests.GetDate(-16)},
];
let attrs_medicine_0 = [{}];

let sleep_entries = [{name:"Went to Bed", date_updated:DataBaseTests.GetDate(-28), date_finished:DataBaseTests.GetDate(-20), has_duration:true},
];
let attrs_sleep_0 = [{name:"Sleep quality", value:"Bad",rating:3}, {name:"Room Temperature", value:"95F",rating:0}];


async function PopulateEntry(entries_data:Array<any>, attr_0:Array<any>, user_db:UserDB, cat_db:CatDB)
{
    // for (const entry_data of test_entries)
    for (let j = 0; j < entries_data.length; j++) 
    {
        const entry_data = entries_data[j];
        //add new item types
        let item = {id_user:user_db.id, id_cat:cat_db.id, ...entry_data}
        let result = await db.item_types.add(new ItemTypeDB(item));
        let item_db = await db.item_types.get(result) as ItemTypeDB;

		

        //now add entries for each
        let entry = {id_user:user_db.id, id_cat:cat_db.id, id_item_type:item_db.id, 
            date_updated:entry_data.date_updated, 
            date_finished:entry_data.date_finished,
            has_duration:entry_data.has_duration||false};

        result = await db.entries.add(new EntryDB(entry));
        let entry_db = await db.entries.get(result) as EntryDB;

		console.log("added new entry: ",entry," and from db: ",entry_db);
		

        if(j==0) //because I added attributes just for the first item in the entry types
        {
            for (const attr of attr_0) 
            {
				//skip blank ones here/ attrs_medicine_0
				if(!attr.name&&!attr.value)
					continue;

                //add attributes if needed
                let entry_attr = {id_user:user_db.id, id_cat:cat_db.id, id_item_type:item_db.id, id_entry:entry_db.id, 
                    ...attr
                };
                result = await db.entry_attributes.add(new EntryAttributeDB().Assign(entry_attr));
                let entry_attr_db = await db.entry_attributes.get(result) as EntryAttributeDB;
				console.log("Dexiedb: Added new attribute", entry_attr_db);
				await ExportImport_.EnsureUniqueTimeStamp(entry_attr_db, ExportImport_.OBJ_ATTRIBUTE);
            }
            
        }
		console.log("ensuring unique key for ", entry_db);
		await ExportImport_.EnsureUniqueTimeStamp(entry_db, ExportImport_.OBJ_ENTRY);
		Data.GetEntryByTimeStamp(entry_db.timestamp);

		

    }
	//should double check to be safe again
	let entries = await db.entries.toArray();
	console.log("All entries: ", entries)
	//check for duplicates
	for (const entry of entries) 
	{
		for (const entry2 of entries)
		{
			if(entry.id==entry2.id)
				continue;

			if(entry.timestamp==entry2.timestamp)
				console.error("ERROR: two entries have the same timestamp!!!", entry, entry2);
		}
		Data.GetEntryByTimeStamp(entry.timestamp);
	}
}

// (db as any).populate_finished=false;
  // Init your DB with some default :
  //it will still be populating when database is ready- so no way to wait for it to populat
 
  var promiseResolve:any, promiseReject;

var promise = new Promise(function(resolve, reject){
  promiseResolve = resolve;
  promiseReject = reject;
});

// db.on("populate", async function() 
// {
// 	// populate_started=true;
// 	// await PopulateTestData();
// 	// console.log("\n\nDone populating data for dexiejs\n\n");
// 	// promiseResolve();

// //   (db as any).populate_finished=false;
// //   throw new Error("Dexiejs done populating")
// });
export async function PopulateIfEmpty()
{
	console.log("populate if empty!");
	await PopulateNewCats();

	let dexie_exists = await db.zzdexiejs_exists.count();
	if(dexie_exists<1)
	{
		await PopulateTestData();
		//also add one to dexiejs exists
		db.zzdexiejs_exists.add(new ZZDexieJSExists());
	}

		
}

//populate any new default categories if I'm adding new custom ones
export async function PopulateNewCats()
{
	console.log("PopulateNewCats!");
	let user_id = UserPrefs.user_selected.value;
	if(user_id=="-1")
	{
		console.log("PopulateNewCats, user_id is -1, skipping.");
		return;
	}

  let user_db = await db.users.get(user_id) as UserDB;
  console.log("user_db: ", user_db)

  	//if there are no users setup yet, we can't update them with new cats, so return
	if(!user_db)
	{
		console.log("!user_db: returning", user_db)
		return;
	}

	//add default categories
	for (let i = 0; i < cats_default.length; i++) 
	{
		let cat = {...cats_default[i]}  as any;
		cat.id_user=user_db.id;
		cat.date_updated = new Date();
		//@ts-ignore
		cat.id=undefined;

		//check if cat type already exists

		let cat_db_check = await db.cats.where("type").equals(cat.type).toArray();
		console.log("PopulateNewCats, cat_db_check: ", cat_db_check);

		if(cat_db_check)
		{
			console.log("PopulateNewCats, found existing cat with type ", cat.type, "so not creating");
			continue;
		}
		console.log("PopulateNewCats, didn't find existing cat with type ", cat.type, "so creating");

		// let result = await db.cats.add(new CatDB(cat));
		// let cat_db = await db.cats.get(result) as CatDB;

		// console.log("looking for unique cat timestamp")
		// await ExportImport_.EnsureUniqueTimeStamp(cat_db, ExportImport_.OBJ_CAT);
		// console.log("finished looking for cat unique timestamp")
	}
}

export async function PopulateTestData()
{
  console.log("in Dexie, populate!");

  //lets create a default user, default cats, and a couple of default events for yesterday and today
  let user = {name:"User1", date_updated:DataBaseTests.GetDate(-24)};//create them for yesterday
  let result = await db.users.add(new UserDB(user));
  let user_db = await db.users.get(result) as UserDB;

  //add default categories
  for (let i = 0; i < cats_default.length; i++) 
  {
    let cat = {...cats_default[i]}  as any;
    cat.id_user=user_db.id;
    cat.date_updated = DataBaseTests.GetDate(-24);
    //@ts-ignore
    cat.id=undefined;
    // console.log("populate dexiejs, cats: ", cat)
    // let result = await db.cats.add(new CategoryData(cat));
    let result = await db.cats.add(new CatDB(cat));
    let cat_db = await db.cats.get(result) as CatDB;

	console.log("looking for unique cat timestamp")
	await ExportImport_.EnsureUniqueTimeStamp(cat_db, ExportImport_.OBJ_CAT);
	console.log("finished looking for cat unique timestamp")

    //lets also add default entries for cats- have to add new item types as well
    /* 
       {name:"Food", color_bg:"blue", color_txt:"white", icon:"restaurant", date_updated:DataBaseTests.GetDate(-22)}, 
  {name:"Bathroom", color_bg:"brown", color_txt:"white", icon:"wc", date_updated:DataBaseTests.GetDate(-25)},
  {name:"Exercise", color_bg:"yellow", color_txt:"black", icon:"sports_martial_arts", date_updated:DataBaseTests.GetDate(-12)},
  {name:"Mood", color_bg:"blue", color_txt:"white", icon:"mood", date_updated:DataBaseTests.GetDate(-2)},
  {name:"Medicine", color_bg:"purple", color_txt:"white", icon:"pill", date_updated:DataBaseTests.GetDate(-24)},
  {name:"Sleep", color_bg:"red", color_txt:"white", icon:"king_bed", date_updated:DataBaseTests.GetDate(-38)},
    */
    if(cat.name=="Food")
        await PopulateEntry(food_entries, attrs_food_0, user_db, cat_db);
    else if(cat.name=="Bathroom")
        await PopulateEntry(bathroom_entries, attrs_bathroom_0, user_db, cat_db);
    else if(cat.name=="Exercise")
        await PopulateEntry(exercise_entries, attrs_exercise_0, user_db, cat_db);
    else if(cat.name=="Mood")
        await PopulateEntry(mood_entries, attrs_mood_0, user_db, cat_db);
    else if(cat.name=="Medicine")
        await PopulateEntry(medicine_entries, attrs_medicine_0, user_db, cat_db);
    else if(cat.name=="Sleep")
        await PopulateEntry(sleep_entries, attrs_sleep_0, user_db, cat_db);
  }

  //add test entries

  //old default data
  /* for (let i = 0; i < DataBaseTests.users.length; i++) 
  {
    const user = DataBaseTests.users[i];
    // console.log("populate dexiejs, cats: ", cat)
    let result = await db.users.add(new UserDB(user));
    let user_db = await db.users.get(result) as UserDB;

    //should also add the categories for users

    for (let i = 0; i < DataBaseTests.cats_default.length; i++) 
    {
      const cat = {...DataBaseTests.cats_default[i]};
      cat.id_user=user_db.id;
      //@ts-ignore
      cat.id=undefined;
      // console.log("populate dexiejs, cats: ", cat)
      await db.cats.add(new CategoryData(cat));
    }
    console.log("populate dexiejs, done cats");

  }


  for (let i = 0; i < DataBaseTests.item_types.length; i++) 
  {
    const entry = DataBaseTests.item_types[i];
 
    await db.item_types.add(entry);
  }
  console.log("populate dexiejs, done item types");

  console.log("in Dexie, populate, adding item entries: ",DataBaseTests.entries.length );
  for (let i = 0; i < DataBaseTests.entries.length; i++) 
  {
    const entry = DataBaseTests.entries[i];
    console.log("adding entry to populate with value: ", entry);
   
    await db.entries.add(entry);
  }
  console.log("populate dexiejs, done entries");

  for (let i = 0; i < DataBaseTests.entry_attributes.length; i++) 
  {
    const entry = DataBaseTests.entry_attributes[i];

    await db.entry_attributes.add(new EntryAttributeDB().Assign(entry));
  }
  console.log("populate dexiejs, done entry_attributes"); */
}


console.log("comemnting out dexiejs db.open");
// db.open();

// This example uses the WebSocketSyncProtocol included in earlier steps.
// db.syncable.connect ("websocket", "https://syncserver.com/sync");

//also hiding these, since we were only using them to try to sync with a backend
// db.syncable.connect ("my_sync_protocol", "localhost:3000/sync").catch(err => {
//     console.error (`Failed to connect to my backend!: ${err.stack || err}`);
// });
// db.syncable.on('statusChanged', function (newStatus, url) {
//     console.log ("Sync Status changed: " + Dexie.Syncable.StatusTexts[newStatus]);
// });
// db.close();


